/**
 * 성적 추이 그래프 컴포넌트
 * Recharts AreaChart를 사용하여 시간별 학습 진도 표시
 */

import React from 'react';
import { Card } from 'antd';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { ProgressDataPoint } from '../../types/stats';

interface ProgressTrendChartProps {
  progress: ProgressDataPoint[];
  loading?: boolean;
}

export const ProgressTrendChart: React.FC<ProgressTrendChartProps> = ({
  progress,
  loading = false,
}) => {
  // 차트 데이터 변환
  const chartData = progress.map((point) => ({
    날짜: point.date,
    페이지: point.page,
    정답률: point.accuracy,
    정답수: point.correct_problems,
    문제수: point.total_problems,
  }));

  return (
    <Card title="학습 진도 추이" loading={loading}>
      {chartData.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px 0', color: '#999' }}>
          데이터가 없습니다
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={350}>
          <AreaChart
            data={chartData}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="colorAccuracy" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#1890ff" stopOpacity={0.8} />
                <stop offset="95%" stopColor="#1890ff" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="날짜"
              label={{ value: '날짜', position: 'insideBottom', offset: -5 }}
            />
            <YAxis
              domain={[0, 100]}
              label={{ value: '정답률 (%)', angle: -90, position: 'insideLeft' }}
            />
            <Tooltip
              formatter={(value: number, name: string) => {
                if (name === '정답률') {
                  return [`${value.toFixed(1)}%`, name];
                }
                return [value, name];
              }}
              labelFormatter={(label) => `날짜: ${label}`}
            />
            <Legend />
            <Area
              type="monotone"
              dataKey="정답률"
              stroke="#1890ff"
              fillOpacity={1}
              fill="url(#colorAccuracy)"
            />
          </AreaChart>
        </ResponsiveContainer>
      )}
    </Card>
  );
};
